// Minimal GA4 helpers. Safe no-ops if gtag is not available.
export function sendEvent(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (_) {
    // no-op
  }
}

export function sendPageView(path) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      const id = window.GA_MEASUREMENT_ID || 'G-VD254S1Z5T';
      window.gtag('config', id, { page_path: path || window.location.pathname });
    }
  } catch (_) {
    // no-op
  }
}


